<template>
  <div class="vbox">
    <c-header></c-header>
    <section>
      <section class="hbox stretch">
        <section class="map-wrap">
          <!--导航栏-->
          <c-filter
            :search='search'
            :aac='aac'
            :djshow='djshow'
            :focusList='focusList'
            :fouc='fouc'
            :butshow='butshow'
            :screening='screening'
            :newArrScreen='newAutoArr'
            :hShow='newAShow'
            :aab='aab'
            :naab='newAab'
            :qu='qu'
            :qy='qy'
            :clearl='clearl'
            :zoomCode='zoomCode'
            :hoverCityOver='hoverCityOver'
            :hoverCityOut='hoverCityOut'
            :qub='qub'
            :quc='quc'
            :clearjd='clearjd'
            :stract='stract'
            :aba='aba'
            :qua='qua'
            :jg='jg'
            :clearf='clearf'
            :typename='typename'
            :shob='shob'
            :clear='clear'
            :innbool='innbool'
            :jd='jd'
            :sho='sho'
          ></c-filter>
          <!--地图-->
          <aMap
            :zoomCode='zoomCode'
            :markers='markers'
            :createWindow='createWindow'
            :lawyerMarkers='lawyerMarkers'
            :zoomCityShow='zoomCityShow'
            :infowindow='infowindow'
            :getLawyer='getLawyer'
          ></aMap>
        </section>
        <!--侧边栏-->
        <c-aside
          :area='area'
          :stractname='stractname'
          :titNumber='titNumber'
          :number='number'
          :show='show'
          :zoomCode='zoomCode'
          :sho='sho'
          :hoverCityOver='hoverCityOver'
          :hoverCityOut='hoverCityOut'
          :showstr='showstr'
          :stract='stract'
          :aba='aba'
          :sshow='sshow'
          :resuList='resuList'
          :aab='aab'
          :tpage='tpage'
          :ajaxdown='ajaxdown'
          :ajaxup='ajaxup'
          :pagenum='pagenum'
          :detailnum='detailnum'
          :lodshow='lodshow'
          :standbynumber='standbynumber'
          :back='back'
          :toback='toback'
          :textjG='jgtext'
        ></c-aside>
      </section>
    </section>
    <!-- <div class="splash" v-if="lodingbox">
      <div class="splash-img">
        <h1>地图加载中</h1>
      </div>
    </div> -->
  </div>
</template>
<script>
import cHeader from '@/components/header'
import * as main from '../data'
import aMap from '@/components/map'
import cAside from '@/components/aside'
import cFilter from '@/components/filter'
export default {
  components: {cHeader, aMap, cAside, cFilter},
  name: 'hello',
  data () {
    return main.data
  },
  watch: {
    qy: function () {
    }
  },
  created: main.created,
  methods: main.methods
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .map-wrap {
    position: relative;
  }
  .splash {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: white;
    z-index: 888888888;
    text-align: center;
    display: block;
    h1{
      color:$gray-light;
      font-size:16px;
      letter-spacing:1px;
      font-weight:200;
      text-align:center;
      padding-top: 50px;
    }
    .splash-img {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      width: 100px;
      height: 100px;
      &:before{
        content: "";
        position: absolute;
        left: 25px;
        top: 10px;
        width: 50px;
        height: 50px;
        background-color: #3498db;
        animation: csshub-flip 1.2s infinite;
        -webkit-animation: csshub-flip 1.2s infinite;
      }

      @keyframes csshub-flip {
        0% {
          transform: rotate(0);
        }

        50% {
          transform: rotateY(180deg);
        }

        100% {
          transform: rotateY(180deg)  rotateX(180deg);
        }
      }
      @-webkit-keyframes csshub-flip {
        0% {
          transform: rotate(0);
        }

        50% {
          transform: rotateY(180deg);
        }

        100% {
          transform: rotateY(180deg)  rotateX(180deg);
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// index.vue?0b2c6548